import { render, staticRenderFns } from "./SecondDefense.vue?vue&type=template&id=826d8020&"
import script from "./SecondDefense.vue?vue&type=script&lang=js&"
export * from "./SecondDefense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports